export default __webpack_public_path__ + "static/media/seeker-8.cc515832.jpg";